import {
  ASSETS_RESOURCE,
  CONTENT_FEEDS_RESOURCE,
  DEVICE_GROUPS_RESOURCE,
  PLAYLIST_ITEMS_RESOURCE,
  PLAYLISTS_RESOURCE,
  CHANNELS_RESOURCE,
  SCHEDULED_CONTENT_RESOURCE,
  SCHEDULED_DAILY_CONTENT_RESOURCE,
  SPECIAL_CONTENT_RESOURCE,
  TICKER_SERIES_RESOURCE,
  TICKERS_RESOURCE,
  SUBUSER_RESOURCE,
  CAMPAIGN_RESOURCE,
  DEVICE_TAGS_RESOURCE,
  PLAYLISTS_RESOURCE_V2,
} from "../api/resources";
import {
  CONFIRMATION_ACCEPT,
  CONFIRMATION_DENY,
  CONFIRMATION_REQUEST,
} from "../constants/actionTypes";
import { deleteAsset } from "./asset";
import {
  deleteContentFeed,
  deleteDeviceGroup,
  deleteSchedule,
  deleteDailySchedule,
  deleteSpecialContent,
  disableDeviceGroupSchedule,
  fetchDeviceGroups,
  updateDevice,
} from "./device";
import { deletePlaylist, deletePlaylistItem } from "./playlist";
import { deleteChannel } from "./channel";
import { deleteTicker, deleteTickerSeries } from "./ticker";

import { deleteUser } from "./user";
import { deleteCampaign } from "./campaign";

import { deleteAssets } from "./campaign";

import { fetchAssets } from "./asset";

import { deleteDeviceTag } from "./tagActions";
import { deletePlaylistV2 } from "./playlistV2";

/**
 * Confirmation request action. Dispatching this action will cause a popup to show up with the
 * supplied title and message.
 *
 * @param {string} title  The title of the confirmation popup.
 * @param {string} message  The message body of the popup.
 * @param {string} operation  The operation to be performed on the data if accepted.
 * @param {string} resourceType  The resource type.
 * @param {number} id  The id of the resource.
 */
export const confirmationRequest = (
  title,
  message,
  operation,
  resourceType,
  id,
) => ({
  type: CONFIRMATION_REQUEST,
  title,
  message,
  resourceType,
  operation,
  id
});



/**
 * This action is dispatched if the confirmation is accepted. It will dispatch the actual action
 * for the supplied operation on the data.
 *
 * @param operation The operation to perform
 * @param resourceType The resource type
 * @param data The resource id or ids
 */
export const confirmationAccept =
  (operation, resourceType, data) => (dispatch) => {
    dispatch({ type: CONFIRMATION_ACCEPT });
    if (operation === "DELETE") {
      switch (resourceType) {
        case ASSETS_RESOURCE:
          return dispatch(deleteAsset(data));
        case CAMPAIGN_RESOURCE:
          return dispatch(deleteCampaign(data));
        case PLAYLISTS_RESOURCE_V2:
          return dispatch(deletePlaylistV2(data));
        case PLAYLISTS_RESOURCE:
          return dispatch(deletePlaylist(data));
        case PLAYLIST_ITEMS_RESOURCE:
          return dispatch(deletePlaylistItem(data));
        case CHANNELS_RESOURCE:
          return dispatch(deleteChannel(data));
        case TICKER_SERIES_RESOURCE:
          return dispatch(deleteTickerSeries(data));
        case TICKERS_RESOURCE:
          return dispatch(deleteTicker(data));
        case DEVICE_GROUPS_RESOURCE:
          return dispatch(deleteDeviceGroup(data));
        case CONTENT_FEEDS_RESOURCE:
          return dispatch(deleteContentFeed(data));
        case SCHEDULED_CONTENT_RESOURCE:
          return dispatch(deleteSchedule(data));
        case SCHEDULED_DAILY_CONTENT_RESOURCE:
          return dispatch(deleteDailySchedule(data));
        case SPECIAL_CONTENT_RESOURCE:
          return dispatch(deleteSpecialContent(data));
        case SUBUSER_RESOURCE:
          return dispatch(deleteUser(data));
        case DEVICE_TAGS_RESOURCE:
          return dispatch(deleteDeviceTag(data));
      }
    }

    if (operation === "DELETE_MANY") {
      if (resourceType === ASSETS_RESOURCE) {
        let dispatchChain = Promise.resolve();
        console.log("Deleting many", data)
        dispatchChain = dispatchChain.then(() => dispatch(deleteAssets(data)))
        dispatchChain = dispatchChain.then(() => dispatch(fetchAssets(true)))
        return dispatchChain
      }
    }

    if (operation === "REBOOT") {
      dispatch(updateDevice(data, { command: "reboot" }));
    }

    if (operation === "RESTART_APP") {
      dispatch(updateDevice(data, { command: "restart-app" }));  
    }

    if (operation === "CLEAR_UNUSED_MEDIA") {
      dispatch(updateDevice(data, { command: "free-space" })); 
    }

    if (operation === "DISABLE_SCHEDULING") {
      return dispatch(disableDeviceGroupSchedule({ id: data })).then(() => {
        dispatch(fetchDeviceGroups());
        location.reload();
      });
    }
  };

/**
 * This action is dispatched if the confirmation popup is cancelled.
 */
export const confirmationDeny = () => ({
  type: CONFIRMATION_DENY,
});



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/actions/confirmation.js